/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PostFaceToFaceKycRequestRequestBeneficialOwnersInner } from './post-face-to-face-kyc-request-request-beneficial-owners-inner';

/**
 * 
 * @export
 * @interface PostFaceToFaceKycRequestRequest
 */
export interface PostFaceToFaceKycRequestRequest {
    /**
     * 実質的支配者
     * @type {Array<PostFaceToFaceKycRequestRequestBeneficialOwnersInner>}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'beneficialOwners'?: Array<PostFaceToFaceKycRequestRequestBeneficialOwnersInner>;
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateAddress': string;
    /**
     * 法人番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateNumber': string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporatePostalCode': string;
    /**
     * 法人種別(enum)
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateType': PostFaceToFaceKycRequestRequestCorporateTypeEnum;
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'email': string;
    /**
     * 法人名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'organizationName': string;
    /**
     * 代表者住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeAddress': string;
    /**
     * 代表者生年月日(YYYYMMDD)
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeBirthday': string;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeName': string;
    /**
     * 代表者電話番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativePhoneNumber': string;
}

export const PostFaceToFaceKycRequestRequestCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type PostFaceToFaceKycRequestRequestCorporateTypeEnum = typeof PostFaceToFaceKycRequestRequestCorporateTypeEnum[keyof typeof PostFaceToFaceKycRequestRequestCorporateTypeEnum];


